import { NgClass } from '@angular/common';
import { Component, computed, effect, input, signal } from '@angular/core';
import { InitialsPipe } from '@oneComply/shared/pipes/initials.pipe';

@Component({
  selector: 'app-user-avatar',
  standalone: true,
  imports: [NgClass, InitialsPipe],
  templateUrl: './user-avatar.html',
})
export class UserAvatar {
  readonly name = input.required<string>();
  readonly imageUrl = input<string>();
  readonly sizeClass = input('size-9');
  readonly textClass = input('text-sm');

  private readonly imageFailed = signal(false);

  protected readonly showImage = computed(() => {
    const url = this.imageUrl()?.trim();
    return !!url && !this.imageFailed();
  });

  constructor() {
    effect(() => {
      this.imageUrl();
      this.imageFailed.set(false);
    });
  }

  protected onImageError(): void {
    this.imageFailed.set(true);
  }
}

